export const CELL_BORDERS = {
  borderStyle: "solid",
  borderWidth: 0,
  borderColor: "neutral.400",
}
